import { Button, Icon, Tooltip } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { usePlayAllEvents } from '@/hooks/usePlayAllEvents';

export const PlayAllButton = () => {
  const { t } = useTranslation('video');
  const { playAllEvents, disabled, disabledReason } = usePlayAllEvents();

  const button = (
    <Button variant="primary" size="small" onClick={playAllEvents} disabled={disabled}>
      <Icon variant="Play" size="small" />
      {t('playAll')}
    </Button>
  );

  return disabledReason ? <Tooltip content={disabledReason}>{button}</Tooltip> : button;
};
